import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';

const WalkCorranCoastal = () => {

  const dispatch = useDispatch();

  const navigateToActivity = () => {
    dispatch(setActivity("CORRAN_COASTAL"));
  }

  return (
    <div>
      <h2 className="walks-link-heading"><a  onClick={navigateToActivity}>Corran Coastal Path</a></h2>        
      <p className="walk-text">A beautiful coastal walk to the three isles opposite Barrisdsle and return.  Lots of coves for a quick dip in the loch. 
      </p>   
    </div>
  );
}

export default WalkCorranCoastal
